import React from 'react';
import EditorField from './_EditorField';
import { useTheme } from '../../../theme/ThemeContext';

export default function StatWidgetsEditor({ section, dispatch }) {
  const { theme } = useTheme();
  const cfg = section.section_config || {};
  const widgets = cfg.widgets || [];

  const updateWidgets = newWidgets => dispatch({
    type: 'UPDATE_SECTION_CONFIG',
    clientId: section._clientId,
    patch: { widgets: newWidgets },
  });

  const addWidget = () => updateWidgets([
    ...widgets,
    { id: Date.now().toString(), label: 'Stat Label', value: '0', icon: 'bi-bar-chart' },
  ]);

  const removeWidget = id => updateWidgets(widgets.filter(w => w.id !== id));

  const updateWidget = (id, patch) => updateWidgets(
    widgets.map(w => w.id === id ? { ...w, ...patch } : w)
  );

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>Stat Widgets ({widgets.length})</span>
        <button
          type="button"
          className="btn btn-sm"
          style={{ background: theme.primary, color: '#fff', border: 'none', fontSize: 11, padding: '3px 10px' }}
          onClick={addWidget}
        >
          <i className="bi bi-plus me-1" />
          Add Widget
        </button>
      </div>

      {widgets.map((w, idx) => (
        <div key={w.id} style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 10, marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#64748b' }}>Widget {idx + 1}</span>
            <button
              type="button"
              className="btn btn-sm"
              style={{ background: '#fee2e2', color: '#dc2626', border: 'none', padding: '2px 8px', fontSize: 11 }}
              onClick={() => removeWidget(w.id)}
            >
              <i className="bi bi-trash" />
            </button>
          </div>
          <EditorField label="Label">
            <input className="form-control form-control-sm" value={w.label || ''} onChange={e => updateWidget(w.id, { label: e.target.value })} />
          </EditorField>
          <EditorField label="Value / Number">
            <input className="form-control form-control-sm" value={w.value || ''} onChange={e => updateWidget(w.id, { value: e.target.value })} />
          </EditorField>
          <EditorField label="Bootstrap Icon class">
            <input className="form-control form-control-sm" placeholder="bi-bar-chart" value={w.icon || ''} onChange={e => updateWidget(w.id, { icon: e.target.value })} />
          </EditorField>
        </div>
      ))}

      {widgets.length === 0 && (
        <div style={{ textAlign: 'center', padding: '16px 0', color: '#94a3b8', fontSize: 12 }}>
          No widgets yet. Click "Add Widget" to start.
        </div>
      )}
    </div>
  );
}
